/* eslint-disable import/no-unresolved */
import { Dom, Events, _defaultsDeep } from '@brandocms/jupiter'

import Panner from '../Panner'

export default class Panama {
  constructor(app, opts = {}) {
    this.opts = { ...opts }
    this.panners = []
    Dom.all('[data-panner-container]').forEach(c => {
      const panner = new Panner(app, c, opts)
      this.panners.push(panner)
    })

    app.registerCallback(Events.APPLICATION_REVEALED, () => {
      setTimeout(() => {
        this.panners.forEach(panner => {
          panner.refreshBounds(true)
        })
      }, 500)
    })

    window.addEventListener(Events.APPLICATION_RESIZE, () => {
      this.panners.forEach(panner => {
        panner.refreshBounds()
      })
    })
  }
}
